import _ from 'lodash';

export const IS_IE = !_.isNil(global.document && document.documentMode);
export const IS_EDGE = !IS_IE && !!window.StyleMedia;
export const IS_SAMSUNG_BROWSER = navigator.userAgent.match(/SamsungBrowser/i);

export const IS_MOBILE = window.innerWidth <= 576;